import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { Container, Row, Col, Card, CardBody, CardText, CardHeader } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { Filters } from "./Filters";
import Table from "./Table";
import axios from "axios";
import { API_URL, sitename } from "../../../constants/constants";
import moment from "moment";

const BonusReport = props => {
  const [loadingMessage, setLoadingMessage] = useState("1");
  const [selectedMonth, setSelectedMonth] = useState(moment().format("YYYY-MM"));
  const [data, setData] = useState([]);
  const [item, setItem] = useState('All');
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));

  const [totalFirstDeposits, setTotalFirstDeposits] = useState(0);
  const [valueFirstDeposits, setValueFirstDeposits] = useState(0);
  const [totalRafPromos, setTotalRafPromos] = useState(0);
  const [valueRafPromos, setValueRafPromos] = useState(0);
  const [totalLoyaltyPromos, setTotalLoyaltyPromos] = useState(0);
  const [valueLoyaltyPromos, setValueLoyaltyPromos] = useState(0);
  const [totalManualBonuses, setTotalManualBonuses] = useState(0);
  const [valueManualBonuses, setValueManualBonuses] = useState(0);
  const [totalSignUpBonuses, setTotalSignUpBonuses] = useState(0);
  const [valueSignUpBonuses, setValueSignUpBonuses] = useState(0);

  const options = [
    { label: "All", value: "All" },
    { label: "1st Deposit", value: "1st Deposit" },
    { label: "Raf Promo", value: "Raf Promo" },
    { label: "Loyalty Promo", value: "Loyalty Promo" },
    { label: "Manual Bonus", value: "Manual Bonus" },
  ];

  useEffect(() => {
    call();
  }, []);

  useEffect(() => {
    call();
  }, [item, fromDate, toDate]);

  const call = () => {
    setLoadingMessage("1");
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/bonus-report?type=${item}&from=${fromDate}&to=${toDate}`,
    })
    .then(function (response) {
      const responseData = response?.data?.data || [];
      setData(responseData);
      setLoadingMessage("0");

      // Calculate the number and total value for each bonus type
      const calculateTotals = (bonusType) => {
        const filteredBonuses = responseData.filter(bonus => bonus.bonus_type === bonusType);
        const totalCount = filteredBonuses.length;
        const totalValue = filteredBonuses.reduce((total, bonus) => total + parseFloat(bonus.bonus_amount), 0);
        return { totalCount, totalValue };
      };

      const { totalCount: totalFirstDepositsCount, totalValue: totalValueFirstDeposits } = calculateTotals("1st Deposit");
      setTotalFirstDeposits(totalFirstDepositsCount);
      setValueFirstDeposits(totalValueFirstDeposits);

      const { totalCount: totalRafPromosCount, totalValue: totalValueRafPromos } = calculateTotals("Raf Promo");
      setTotalRafPromos(totalRafPromosCount);
      setValueRafPromos(totalValueRafPromos);

      const { totalCount: totalLoyaltyPromosCount, totalValue: totalValueLoyaltyPromos } = calculateTotals("Loyalty Promo");
      setTotalLoyaltyPromos(totalLoyaltyPromosCount);
      setValueLoyaltyPromos(totalValueLoyaltyPromos);

      const { totalCount: totalManualBonusesCount, totalValue: totalValueManualBonuses } = calculateTotals("Manual Bonus");
      setTotalManualBonuses(totalManualBonusesCount);
      setValueManualBonuses(totalValueManualBonuses);

      const { totalCount: totalSignUpBonusesCount, totalValue: totalValueSignUpBonuses } = calculateTotals("SignUp Bonus");
      setTotalSignUpBonuses(totalSignUpBonusesCount);
      setValueSignUpBonuses(totalValueSignUpBonuses);
    })
    .catch(function (error) {
      console.error("Error fetching bonus report data:", error);
      setLoadingMessage("0");
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Admin" breadcrumbItem="Bonus Report" />
        </Container>
        <Row>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Total 1st Deposits</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {totalFirstDeposits.toLocaleString()}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Value 1st Deposit</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {valueFirstDeposits.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Total Raf Promo</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {totalRafPromos.toLocaleString()}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Value Raf Promo</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {valueRafPromos.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Total Loyalty Promo</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {totalLoyaltyPromos.toLocaleString()}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Value Loyalty Promo</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {valueLoyaltyPromos.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Total Manual Bonuses</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {totalManualBonuses.toLocaleString()}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Value Manual Bonuses</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {valueManualBonuses.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Total SignUp Bonuses</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {totalSignUpBonuses.toLocaleString()}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">Value SignUp Bonuses</CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {valueSignUpBonuses.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Filters
          item={item}
          setItem={setItem}
          options={options}
          fromDate={fromDate}
          toDate={toDate}
          setToDate={setToDate}
          setFromDate={setFromDate}
        />
        <Table data={data}  loadingMessage={loadingMessage} setLoadingMessage={setLoadingMessage}/>
      </div>
    </React.Fragment>
  );
}

export default withRouter(BonusReport);
